var map = {
	"./bgw.png": "dc4f",
	"./binance.png": "41f1",
	"./binancewallet.png": "ad43",
	"./bitget.png": "ca99",
	"./bybit.png": "c892",
	"./coinbasewallet.png": "d620",
	"./gateio.png": "24a5",
	"./imtoken.png": "7d9f",
	"./kucoin.png": "b64d",
	"./metamask.png": "6e8b",
	"./okx.png": "1d7d",
	"./okxwallet.png": "cf78",
	"./phantom.png": "1ecb",
	"./rainbow.png": "bfeb",
	"./tokenpocket.png": "bbe2",
	"./trustwallet.png": "7c64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e70";